import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MouseEventHandler } from 'react';

export interface FAQListItemProps {
    active?: boolean;
    onClick: MouseEventHandler<HTMLAnchorElement>;
    text: string;
}

export const FAQListItem = ((props: FAQListItemProps) => {
    return (
        <span className={`${props.active ? 'active' : ''} cursor-pointer dropdown-item py-2 px-4 me-4`} onClick={props.onClick}>
            <span className="text-avenir-re text-uppercase me-3">{props.text}</span>
            <FontAwesomeIcon size="sm" icon="chevron-right" />
        </span>
    );
});